export default "__VITE_ASSET__175d7ac1__"